export const NAME = 'auth';

export const AUTH_PROVIDERS = {
  GOOGLE: 'google.com',
  PASSWORD: 'password',
};
